import React, { useState } from "react";
import ProgressBar from "../Common/ProgressBar";
import RadioButton from "../../../UI/RadioButton";
import TextField from '../../../UI/TextField';
import InputButton from "../../../UI/InputButton";

const Documements = ({
  className,
  slideChange,
  textHeadingLine1,
  textHeadingLine2,
  validation,
  backClick,
  validationMsg,
  trigger,
  setSkipAgNo
}) => {
  const [checkedOne, setCheckedOne] = useState("unchecked");
  const [checkedTwo, setCheckedTwo] = useState("unchecked");
  const [checkedThree, setCheckedThree] = useState("unchecked");
  const [checkedFour, setcheckedFour] = useState("unchecked");
  const [checkedFive, setcheckedFive] = useState("unchecked");
  const [checkedSix, setcheckedSix] = useState("unchecked");
  const [agNoShow, setAgNoShow] = useState("hide");
  const nextSlide = async (e) => {
    if (e.target.value === "124") {
      setCheckedOne("checked");
      setAgNoShow('show');
    } else {
      setCheckedOne("unchecked");
    }

    if (e.target.value === "125") {
      setCheckedTwo("checked");
      slideChange(e);
    } else {
      setCheckedTwo("unchecked");
    }

    if (e.target.value === "120") {
      setCheckedThree("checked");
      slideChange(e);
    } else {
      setCheckedThree("unchecked");
    }

    if (e.target.value === "126") {
      setcheckedFour("checked");
      slideChange(e);
    } else {
      setcheckedFour("unchecked");
    }

    if (e.target.value === "127") {
      setcheckedFive("checked");
      slideChange(e);
    } else {
      setcheckedFive("unchecked");
    }

    if (e.target.value === "123") {
      setcheckedSix("checked");
      slideChange(e);
    } else {
      setcheckedSix("unchecked");
    }
  };
  const agreementValidation = async (e) => {
    let agreement_no = await trigger("question_45");
    if (agreement_no) {
      slideChange(e);
      setAgNoShow('hide');
    } else {
      return false;
    }
  };
  const skip_agree_no = async (e) =>{
    setAgNoShow('hide');
    slideChange(e);
    setSkipAgNo(true);
  };
  return (
    <>
      <div id="slide-7" className={`${className}`}>
        <ProgressBar value="50" />

        <h3> {textHeadingLine1} </h3>
        <h4> {textHeadingLine2} </h4>
        <div className="radio_buttons">
        <div className="btn-comm">
          <RadioButton
            value="124"
            name="document"
            className="radio-button"
            labelName="Your Loan / Credit Card Number"
            labelClassName={`option_but radio ${checkedOne}`}
            onClick={nextSlide}
            validation={validation()}
          />
          </div>
          <div className="btn-comm">
          <RadioButton
            value="125"
            name="document"
            className="radio-button"
            labelName="Any documents relating to your Loan/Credit Card"
            labelClassName={`option_but radio ${checkedTwo}`}
            onClick={nextSlide}
            validation={validation()}
          />
          </div>
          {/* <div className="btn-comm">
          <RadioButton
            value="120"
            name="document"
            className="radio-button"
            labelName="A Statement of Account"
            labelClassName={`option_but radio ${checkedThree}`}
            onClick={nextSlide}
            validation={validation()}
          />
          </div> */}
          <div className="btn-comm">
          <RadioButton
            value="126"
            name="document"
            className="radio-button"
            labelName="Bank Statements (One Month Before and After the Start of Your Loan/ Credit card(s)"
            labelClassName={`option_but radio ${checkedFour}`}
            onClick={nextSlide}
            validation={validation()}
          />
          </div>
          <div className="btn-comm">
          <RadioButton
            value="127"
            name="document"
            className="radio-button"
            labelName="Arrears Letters"
            labelClassName={`option_but radio ${checkedFive}`}
            onClick={nextSlide}
            validation={validation()}
          />
          </div>
          <div className="btn-comm">
          <RadioButton
            value="123"
            name="document"
            className="radio-button"
            labelName="None of the Above"
            labelClassName={`option_but radio ${checkedSix}`}
            onClick={nextSlide}
            validation={validation()}
          />
          </div>
        </div>
        <p className="text-center">
          <span
            className="back-btn btn-link"
            name="back07"
            children="<< Previous"
            onClick={backClick}
          ></span>
        </p>
        <div role="dialog" className={`fade modal blackover ${agNoShow}`}>
          <div className="modal-dialog modal-md modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-body">
                <h3 className="text-center fonts15">Enter your Loan / Credit Card Number</h3>
                <div className="input-group mb-3 justify-content-center">
                  <div className="mb-3 mt-3 col-12 p-0">
                    <div className="input-group mb-3">
                      <TextField
                        type="tel"
                        className="form-control"
                        placeholder="Loan / Credit Card Number"
                        // name="question_51"
                        name="question_45"
                        validation={validation({
                          required: "Please Enter Loan / Credit Card Number",
                          minLength: {
                            value: 3,
                            message: "Please Enter Valid Loan / Credit Card Number",
                          },
                          pattern: {
                            value: /^\d*[1-9]\d*$/,
                            message:
                              "Loan / Credit Card Number is Invalid. Please Recheck",
                          },
                        })}
                        validationMsg={
                          validationMsg.question_45 &&
                          validationMsg.question_45.message
                        }
                      ></TextField>
                    </div>

                    <InputButton
                      name="agreement_no"
                      className="btn next08 regNextBtn"
                      id=""
                      value="Next"
                      btnType="button"
                      onClick={agreementValidation}
                      style={{ float: "none" }}
                    />
                    <p className="text-center">
                    <InputButton
                      name="skip_agree_no"
                      className="btn btn-link"
                      id=""
                      value="SKIP for now and follow up ASAP"
                      btnType="button"
                      onClick={skip_agree_no}
                      style={{ float: "none" }}
                    />
                    </p>

                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Documements;